import React from "react"
import { Bookmark, FileText } from "lucide-react"
import type { BookmarkCardViewModel } from "../types"
import "./BookmarkCard.style.scss"

interface BookmarkCardProps {
  card: BookmarkCardViewModel
  removing: boolean
  selected?: boolean
  onOpen: () => void
  onRemove: () => void
}

const BookmarkCard = ({
  card,
  removing,
  selected = false,
  onOpen,
  onRemove,
}: BookmarkCardProps) => (
  <article className={`bookmark-card${selected ? " is-selected" : ""}`}>
    <div className="bookmark-card__chips">
      <span className="bookmark-card__chip is-subject">{card.subjectTitle}</span>
      {card.yearLabel && (
        <span className="bookmark-card__chip">{card.yearLabel}</span>
      )}
      {card.topicPath && (
        <span className="bookmark-card__chip">{card.topicPath}</span>
      )}
    </div>

    <p className="bookmark-card__snippet">{card.snippet}</p>

    <div className="bookmark-card__footer">
      {card.hasSolution ? (
        <span className="bookmark-card__solution">
          <FileText size={14} /> Solution available
        </span>
      ) : (
        <span />
      )}
      <div className="bookmark-card__actions">
        <button
          type="button"
          aria-label="Remove bookmark"
          disabled={removing}
          onClick={onRemove}
        >
          <Bookmark size={16} fill="currentColor" />
        </button>
        <button
          type="button"
          className="bookmark-card__view"
          disabled={removing}
          onClick={onOpen}
        >
          View full
        </button>
      </div>
    </div>
  </article>
)

export default BookmarkCard
